module.exports = __webpack_public_path__ + "img/Tiempo-N.8825b3ee.png";